import { AccountObject, IAccountObjectArgs } from "../account-object/account-object.model";

export interface IArgs extends IAccountObjectArgs {
    claimedBy?: string;
    done?: boolean;
    dueDate?: string;
    job: string;
    taskType: string;
    title?: string;
}

const defaults = {
    claimedBy: "",
    done: false,
    dueDate: "",
    job: undefined,
    taskType: undefined,
    title: ""
} as IArgs;

export class Task extends AccountObject {
    claimedBy: string;
    done: boolean;
    dueDate: string;
    job: string;
    taskType: string;
    title: string;

    constructor(data?: IArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task/task.model.ts